// extracted by mini-css-extract-plugin
export default {"cardPrice":"addTest_cardPrice__Fquor","cardBtn":"addTest_cardBtn__f6nYt"};